import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setSectorPage } from '../redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useSectorSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getSectorSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website.sector_page.sector_section}`);
      console.log("🚀 ~ getSectorSectionJson ~ data:", response);
      console.log("🚀 ~ getSectorSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setSectorPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Sector section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getSectorSectionJson();
  }, [getSectorSectionJson]);

  return {
    data,
    loading,
    error,
    getSectorSectionJson,
    fetchOnMount,
    refetch: getSectorSectionJson
  };
};

export default useSectorSection;
